import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Cards from './Cards';
import LargeModule from '../LargeModule';
import { getSliceAnchorId } from '../../selectors';

const DiscoverSports = ({ anchorId, className, sliceId }) => (
  <LargeModule id={anchorId} className={className} sliceId={sliceId}>
    <Cards sliceId={sliceId} />
  </LargeModule>
);

DiscoverSports.defaultProps = {
  anchorId: undefined,
};

DiscoverSports.propTypes = {
  anchorId: PropTypes.string,
  className: PropTypes.string,
  sliceId: PropTypes.number.isRequired,
};

DiscoverSports.defaultProps = {
  className: undefined,
};

const mapStateToProps = (state, { sliceId }) => ({
  anchorId: getSliceAnchorId(state, sliceId),
});

export default connect(mapStateToProps)(DiscoverSports);
